import { styled } from "@mui/material/styles";
import { Box, Backdrop, Grid2, Typography } from "@mui/material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
}));

export const GridContainer = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(4),
  alignItems: "stretch",
}));

export const GridItem = styled(Grid2)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("lg")]: {
    size: 6,
  },
  [theme.breakpoints.down("md")]: {
    fontSize: 6,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 6,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: 12,
  },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "bold",
  fontSize: "18px",
  color: theme.palette.text.primary,
}));
